module.exports = "pegasus_template/assets/theme4/header-image.jpg";